import { createBrowserRouter } from 'react-router-dom';
import App from '../App';
import AppRouter from '../components/AppRouter';

// Simple router configuration
export const router = createBrowserRouter([
  {
    path: "/*",
    element: <App><AppRouter /></App>,
  },
]);

// Route paths for easy reference
export const ROUTES = {
  SIGNIN: '/signin',
  DASHBOARD: '/dashboard',
  GAME_LOBBY: '/game-lobby',
  LOBBY: '/game-lobby/lobby',
  WAITING: '/game-lobby/waiting',
  GAME: '/game-lobby/game',
  WAITING_WITH_ROOM: (roomId) => `/game-lobby/waiting/${roomId}`,
  GAME_WITH_ROOM: (roomId) => `/game-lobby/game/${roomId}`,
};
